module.exports = __webpack_public_path__ + "img/left_4.9112dc26.jpg";